import { ApiClient } from '../../common/api/apiClient'
import { PlannerName } from '../../common/enums/PlannerNameEnum'
import { IResult } from '../../common/types/IResult'
import { ICreateAdditionalWave } from '../types/ICreateAdditionalWave'

export const createAdditionalWave = async (
  apiClient: ApiClient,
  data: ICreateAdditionalWave,
): Promise<IResult> => {
  const body = JSON.stringify(data)
  const response = await apiClient.post(
    PlannerName.Bakery,
    'waves/createAdditionalWave',
    body,
  )
  return (await response.json()) as IResult
}
